import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { Route, Routes, Navigate } from "react-router-dom";
import Main from "./pages/main/Main";
import Introduce from "pages/main/Introduce";
import Career from "pages/main/Career";
import Contact from "pages/main/Contact";
import Solutions from "pages/main/Solutions";

const App = () => {
  return (
    <HelmetProvider>
      <Routes>
        {/* 대표 홈 URL */}
        <Route path="/" element={<Main />} />
        {/* 예전 URL은 홈으로 통일 */}
        <Route path="/index.html" element={<Navigate replace to="/" />} />
        <Route path="/main" element={<Navigate replace to="/" />} />
        <Route path="/introduce/:section" element={<Introduce />}></Route>
        <Route path="/solutions/:section" element={<Solutions />}></Route>
        <Route path="/career" element={<Career />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
      </Routes>
    </HelmetProvider>
  );
};

export default App;
